<template>
  <div class="auth-page">
    <button
      type="button"
      class="welcome-back-btn"
      aria-label="Back to welcome"
      @click="
        $playSound();
        $router.push('/welcome');
      "
    >
      <i class="fas fa-home"></i>
    </button>

    <img
      class="auth-logo"
      src="/logo.png"
      alt=""
      @click="$router.push('/home')"
    />

    <section class="auth-card">
      <h3 class="auth-title">{{ $t("auth.login") }}</h3>
      <div class="error" v-if="error">
        {{ $t("auth.fail_message") }}
      </div>

      <form role="form">
        <label>{{ $t("auth.phone") }}</label>
        <input
          class="form-control"
          type="tel"
          inputmode="numeric"
          autocomplete="tel"
          v-model="phone"
          @keyup.enter="focusOnPasswordInputBox"
        />
        <small class="error-text">{{ errors.phone }}</small>

        <label>{{ $t("auth.password") }}</label>
        <div class="password-wrap">
          <input
            class="form-control"
            type="password"
            ref="password"
            v-model="password"
            @keyup.enter="loginWithPhone"
          />
          <i
            class="far fa-eye showable-password"
            v-if="isShow"
            @click="
              $playSound();
              showablePassword();
            "
          ></i>
          <i
            class="fas fa-eye-slash showable-password"
            v-if="!isShow"
            @click="
              $playSound();
              showablePassword();
            "
          ></i>
        </div>
        <small class="error-text">{{ errors.password }}</small>

        <button
          type="button"
          class="forgot-link"
          @click="
            $playSound();
            showForgotPassword = true;
          "
        >
          {{ $t("auth.forgot_password") }}
        </button>

        <button
          type="button"
          class="submit-btn"
          @click="
            $playSound();
            loginWithPhone();
          "
        >
          <span v-if="!isSignin">{{ $t("auth.login") }}</span>
          <Loading color="#1a1408" v-if="isSignin" size="22" />
        </button>
      </form>

      <button
        type="button"
        class="switch-link"
        @click="$router.push('/auth/register')"
      >
        {{ $t("auth.go_register") }}
      </button>
    </section>

    <van-popup
      v-model="showForgotPassword"
      round
      closeable
      position="bottom"
      class="forgot-popup"
    >
      <div class="forgot-panel">
        <h4>{{ $t("auth.forgot_password_title") }}</h4>
        <p>{{ $t("auth.forgot_password_hint") }}</p>
        <div class="contact-options">
          <a
            :href="telegramLink"
            target="_blank"
            rel="noopener noreferrer"
            class="contact-option"
            @click="$playSound()"
          >
            <img
              src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/smt223_telegram.png"
              alt="Telegram"
              class="contact-icon-img"
            />
            <span>Telegram</span>
          </a>
          <a
            :href="viberLink"
            class="contact-option"
            @click="$playSound()"
          >
            <img
              src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/smt223_viber.png"
              alt="Viber"
              class="contact-icon-img"
            />
            <span>Viber</span>
          </a>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Toast, Loading } from "vant";
import { mapActions } from "vuex";

export default {
  components: { Loading },
  data() {
    return {
      phone: null,
      password: null,
      error: false,
      errors: {},
      isSignin: false,
      isShow: false,
      showForgotPassword: false,
      telegramLink: "https://t.me/bgnmoung_bot",
      viberLink: "https://msng.link/o/?959961896222=vip",
    };
  },
  methods: {
    ...mapActions(["fetchUser"]),
    showablePassword() {
      if (this.isShow) {
        this.$refs.password.type = "password";
      } else {
        this.$refs.password.type = "text";
      }
      this.isShow = !this.isShow;
    },
    focusOnPasswordInputBox() {
      this.$refs.password.focus();
    },
    /**
     * login with phone
     */
    async loginWithPhone() {
      this.isSignin = true;
      this.errors = {};
      if (!this.phone) {
        this.errors.phone = this.$t("auth.require_phone");
        this.isSignin = false;
        return false;
      }
      if (!this.password) {
        this.errors.password = this.$t("auth.require_password");
        this.isSignin = false;
        return false;
      }
      try {
        if (this.phone === "testuser") {
          window.open("https://about.myanmarsoccer.xyz", "_self");
        } else {
          const res = await this.axios.post(
            "/auth/login",
            {
              phone: this.phone,
              password: this.password,
              roles: "normal",
              fcm: localStorage.getItem("fcm"),
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );
          localStorage.setItem("phone", this.phone);
          localStorage.setItem("password", this.password);
          localStorage.setItem("token", res.data.token);

          const currentTime = new Date();
          localStorage.setItem(
            "tokenExpire",
            new Date(currentTime.getTime() + 60 * 60 * 1000)
          );
          await this.fetchUser();
          this.$router.push("/home");
          // this.$router.go();
          // ..
          Toast.success(
            this.$store.state.language === "en" ? "Success!" : "Success!"
          );
        }
      } catch (err) {
        this.error = true;
      }
      this.isSignin = false;
      return true;
    },
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (authUser && this.$store.state.authUser.roles === "normal")
      this.$router.push("/home");
    const phone = localStorage.getItem("phone");
    const password = localStorage.getItem("password");
    if (phone && password) {
      this.phone = phone;
      this.password = password;
    }
  },
};
</script>

<style scoped>
.auth-page {
  min-height: 100vh;
  padding: 28px 16px 4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
.welcome-back-btn {
  position: fixed;
  top: 16px;
  right: 16px;
  width: 42px;
  height: 42px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  background: #1c1c1c;
  color: #f7d56a;
  display: grid;
  place-items: center;
  cursor: pointer;
  z-index: 10;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);
}
.welcome-back-btn i {
  font-size: 1rem;
}
.auth-logo {
  height: 88px;
  margin: 12px 0 18px;
  cursor: pointer;
  object-fit: contain;
}
.auth-card {
  width: 100%;
  max-width: 420px;
  background: #1c1c1c;
  border-radius: 16px;
  padding: 18px 16px 16px;
}
.auth-title {
  margin: 0 0 14px;
  color: #f0e6c8;
  font-size: 1.15rem;
  font-weight: 700;
  text-align: center;
}
.auth-card label {
  display: block;
  margin-bottom: 6px;
  color: #f0e6c8;
  font-weight: 600;
}
.auth-card .form-control {
  height: 2.7rem;
  border-radius: 10px;
  margin-bottom: 4px;
}
.password-wrap {
  position: relative;
}
.showable-password {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #c9c3b8;
  cursor: pointer;
  z-index: 2;
}
.error-text {
  display: block;
  min-height: 1em;
  margin-bottom: 10px;
  color: #ff8a6a;
  font-size: 0.78rem;
}
.error {
  margin-bottom: 12px;
  padding: 8px 12px;
  border-radius: 10px;
  background: #2a1612;
  color: #ff8a6a;
  text-align: center;
  font-size: 0.85rem;
}
.submit-btn {
  width: 100%;
  height: 2.7rem;
  margin-top: 8px;
  border: 0;
  border-radius: 12px;
  background: linear-gradient(180deg, #f7d56a, #e7b534);
  color: #1a1408;
  font-weight: 700;
  cursor: pointer;
}
.switch-link {
  display: block;
  width: 100%;
  margin-top: 12px;
  border: 0;
  background: transparent;
  color: #d8c48a;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
}
.forgot-link {
  display: block;
  width: 100%;
  margin: -4px 0 12px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #d8c48a;
  font-size: 0.8rem;
  font-weight: 600;
  text-align: right;
  cursor: pointer;
}
.forgot-panel {
  padding: 20px 16px 28px;
  background: #1c1c1c;
}
.forgot-panel h4 {
  margin: 0 0 8px;
  color: #f0e6c8;
  font-size: 1rem;
  font-weight: 700;
  text-align: center;
}
.forgot-panel p {
  margin: 0 0 18px;
  color: #c9c3b8;
  font-size: 0.82rem;
  text-align: center;
}
.contact-options {
  display: flex;
  gap: 12px;
}
.contact-option {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 16px 12px;
  border-radius: 12px;
  background: #161616;
  border: 1px solid rgba(255, 255, 255, 0.08);
  text-decoration: none;
  transition: border-color 0.2s, background 0.2s;
}
.contact-option:active {
  background: #222;
  border-color: rgba(231, 181, 52, 0.35);
}
.contact-icon-img {
  width: 52px;
  height: 52px;
  object-fit: contain;
  border-radius: 12px;
}
.contact-option span {
  color: #f0e6c8;
  font-size: 0.9rem;
  font-weight: 600;
}
</style>

<style>
.forgot-popup.van-popup {
  background: #1c1c1c;
}
.forgot-popup .van-popup__close-icon {
  color: #f0e6c8;
}
